
export const calculateMatchResults = (matches: any[], isHalfTime: boolean = false) => {
  if (!matches || matches.length === 0) {
    return {
      homeWinPercentage: "0.0",
      drawPercentage: "0.0",
      awayWinPercentage: "0.0",
      popularScores: [],
      homeWinScores: [],
      awayWinScores: [],
      drawScores: {
        all: [],
        higher: [],
        neutral: []
      }
    };
  }

  const totalMatches = matches.length;
  const homeWins = matches.filter(match => 
    isHalfTime ? match.HTR === 'H' : match.FTR === 'H'
  ).length;
  const draws = matches.filter(match => 
    isHalfTime ? match.HTR === 'D' : match.FTR === 'D'
  ).length;
  const awayWins = matches.filter(match => 
    isHalfTime ? match.HTR === 'A' : match.FTR === 'A'
  ).length;

  console.log('Total matches:', totalMatches);
  console.log('Draws:', draws);

  // Define specific home win scores to track
  const homeWinScoresToTrack = ['1-0', '2-0', '2-1', '3-0', '3-1', '3-2', '4-0', '4-1', '4-2', '4-3'];
  
  // Define specific away win scores to track
  const awayWinScoresToTrack = ['0-1', '0-2', '1-2', '0-3', '1-3', '2-3', '0-4', '1-4', '2-4', '3-4'];
  
  // Define specific draw scores to track
  const drawScoresToTrack = {
    homeScoring: ['2-2', '3-3', '4-4'], // Home team scores 2 or more
    awayScoring: ['1-1'], // Away team scores first
    neutral: ['0-0'] // No goals
  };

  // Calculate home win scores frequencies
  const homeWinScores = homeWinScoresToTrack.map(score => {
    const [homeGoals, awayGoals] = score.split('-').map(Number);
    const count = matches.filter(match => 
      (isHalfTime ? match.HTR === 'H' : match.FTR === 'H') && 
      parseInt(isHalfTime ? match.HTHG : match.FTHG) === homeGoals && 
      parseInt(isHalfTime ? match.HTAG : match.FTAG) === awayGoals
    ).length;
    
    return {
      score,
      count,
      percentage: ((count / totalMatches) * 100).toFixed(1)
    };
  }).filter(score => score.count > 0)
    .sort((a, b) => b.count - a.count);

  // Calculate away win scores frequencies
  const awayWinScores = awayWinScoresToTrack.map(score => {
    const [homeGoals, awayGoals] = score.split('-').map(Number);
    const count = matches.filter(match => 
      (isHalfTime ? match.HTR === 'A' : match.FTR === 'A') && 
      parseInt(isHalfTime ? match.HTHG : match.FTHG) === homeGoals && 
      parseInt(isHalfTime ? match.HTAG : match.FTAG) === awayGoals
    ).length;
    
    return {
      score,
      count,
      percentage: ((count / totalMatches) * 100).toFixed(1)
    };
  }).filter(score => score.count > 0)
    .sort((a, b) => b.count - a.count);

  // Calculate home scoring draws (2-2, 3-3, 4-4)
  const homeScoringDraws = drawScoresToTrack.homeScoring.map(score => {
    const [homeGoals, awayGoals] = score.split('-').map(Number);
    const count = matches.filter(match => 
      (isHalfTime ? match.HTR === 'D' : match.FTR === 'D') && 
      parseInt(isHalfTime ? match.HTHG : match.FTHG) === homeGoals && 
      parseInt(isHalfTime ? match.HTAG : match.FTAG) === awayGoals
    ).length;
    
    return {
      score,
      count,
      percentage: ((count / totalMatches) * 100).toFixed(1)
    };
  }).filter(score => score.count > 0)
    .sort((a, b) => b.count - a.count);

  // Calculate away scoring draws (1-1)
  const awayScoringDraws = drawScoresToTrack.awayScoring.map(score => {
    const [homeGoals, awayGoals] = score.split('-').map(Number);
    const count = matches.filter(match => 
      (isHalfTime ? match.HTR === 'D' : match.FTR === 'D') && 
      parseInt(isHalfTime ? match.HTHG : match.FTHG) === homeGoals && 
      parseInt(isHalfTime ? match.HTAG : match.FTAG) === awayGoals
    ).length;
    
    return {
      score,
      count,
      percentage: ((count / totalMatches) * 100).toFixed(1)
    };
  }).filter(score => score.count > 0)
    .sort((a, b) => b.count - a.count);

  // Calculate 0-0 draws
  const neutralDrawScores = drawScoresToTrack.neutral.map(score => {
    const [homeGoals, awayGoals] = score.split('-').map(Number);
    const count = matches.filter(match => 
      (isHalfTime ? match.HTR === 'D' : match.FTR === 'D') && 
      parseInt(isHalfTime ? match.HTHG : match.FTHG) === homeGoals && 
      parseInt(isHalfTime ? match.HTAG : match.FTAG) === awayGoals
    ).length;
    
    return {
      score,
      count,
      percentage: ((count / totalMatches) * 100).toFixed(1)
    };
  }).filter(score => score.count > 0);

  // Combine all draws and sort by count
  const higherDrawScores = [...homeScoringDraws, ...awayScoringDraws]
    .sort((a, b) => b.count - a.count);

  // Calculate all draw scores combined and sorted by count
  const allDrawScores = [...neutralDrawScores, ...higherDrawScores]
    .sort((a, b) => b.count - a.count);

  // Calculate general score frequencies for popular scores
  const scoreFrequencies: { [key: string]: number } = {};
  matches.forEach(match => {
    if (
      (isHalfTime ? match.HTHG : match.FTHG) !== undefined && 
      (isHalfTime ? match.HTAG : match.FTAG) !== undefined
    ) {
      const score = `${isHalfTime ? match.HTHG : match.FTHG}-${isHalfTime ? match.HTAG : match.FTAG}`;
      scoreFrequencies[score] = (scoreFrequencies[score] || 0) + 1;
    }
  });

  const popularScores = Object.entries(scoreFrequencies)
    .map(([score, count]) => ({
      score,
      count,
      percentage: ((count / totalMatches) * 100).toFixed(1)
    }))
    .sort((a, b) => parseFloat(b.percentage) - parseFloat(a.percentage))
    .slice(0, 5);

  // Return all calculated statistics
  return {
    homeWinPercentage: ((homeWins / totalMatches) * 100).toFixed(1),
    drawPercentage: ((draws / totalMatches) * 100).toFixed(1),
    awayWinPercentage: ((awayWins / totalMatches) * 100).toFixed(1),
    popularScores,
    homeWinScores,
    awayWinScores,
    drawScores: {
      all: allDrawScores,
      higher: higherDrawScores,
      neutral: neutralDrawScores
    }
  };
};
